import api from '../config';

export default async function postJSON(path, options) {
  const response = await fetch(api + path, options);
  const result = await response.json();

  return result;
}
